import React, { useEffect, useMemo } from 'react'
import Styles from './ReduxErrorHandler.module.scss'
import { useDispatch, useSelector, useStore } from 'react-redux'
import { FieldPath } from '@onepercentio/one-ui/types'
import store, { RootState } from 'core/modules/redux'
import { startTenantFetch } from 'core/logic/tenant/tenant.sagas'
import { get } from 'lodash'
import { useToast } from 'context/ToastAlert'
import { runSaga } from 'redux-saga'
import { startTermsFetch } from 'core/logic/terms/terms.sagas'
import { t } from 'translate/i18n'
import { assetActions } from 'core/logic/asset/asset.reducer'

const errorKeysAndAction: [
  keyToCheck: FieldPath<RootState>,
  retryFunc: () => void
][] = [
  ['tenant.errorKey', () => runSaga(store, startTenantFetch)],
  ['terms.errorKey', () => runSaga(store, startTermsFetch)],
  ['asset.errorKey', () => store.dispatch(assetActions.fetchAssets())],
]

/**
 * Provides a way to refresh error
 **/
export default function ReduxErrorHandler() {
  const store = useSelector<RootState, RootState>((s: any) => s)

  const keyValues = errorKeysAndAction
    .map((a) => [...a, get(store, a[0])])
    .filter(([key]) => {
      return !!get(store, key)
    })
  const actions = keyValues.map(([_, action]) => action)
  const { showAlert } = useToast()

  useEffect(() => {
    if (actions.length)
      showAlert(t('generic.errorMsg'), 'error', {
        label: t('generic.retryBtn'),
        action() {
          console.log('Calling failed actions')
          for (let action of actions) action()
        },
      })
  }, [actions.length])

  return <></>
}
